import React, { LabelHTMLAttributes, InputHTMLAttributes } from 'react';
import classnames from 'classnames';
import { RequiredAsterisk } from './utils.component';
import styles from './input.module.scss';

interface InputProps {
  className?: string;
  label: string;
  labelProps?: LabelHTMLAttributes<HTMLLabelElement>;
  inputProps: InputHTMLAttributes<HTMLInputElement>;
  hasError?: boolean;
  errorMessage?: string;
}

const InputContainer = (props: InputProps) => {
  const {
    inputProps: {
      id,
      className: inputClassname,
      required,
      ...inputPropsRest
    },
    hasError = false,
    errorMessage,
    label,
    labelProps,
    className,
    ...restProps
  } = props;

  return (
    <div className={classnames(styles.flexLabelContainer, className)} {...restProps}>
      <div className={styles.labelContainer}>
        <label htmlFor={id} {...labelProps}>
          {required && <RequiredAsterisk />}{' '}{label}
        </label>
        <input
          type='text'
          id={id}
          className={classnames(styles.input, inputClassname, { [styles.inputError]: hasError })}
          required={required}
          {...inputPropsRest}
        />
      </div>
      {hasError && <span className={styles.errorMessage}>{errorMessage}</span>}
    </div>
  );
}

export default InputContainer;
